import type { MenuStudentModel } from '@/components/domains/menu_student_model'
import type { MenuStudentEntity } from '../entity/menu_student_entity'

export class MenuStudentMapper {
  public static toFrom(payload: MenuStudentEntity[]): MenuStudentModel[] {
    return payload.map((data) => {
      return {
        id: data.work_shop_id,
        name: data.tipo_taller,
      }
    })
  }
}
